/*
 * Public API Surface of surf-own-arrangements
 */

export * from './lib/own-arrangements/own-arrangements.component';
export * from './lib/surf-own-arrangements.module';
